module.exports = __webpack_public_path__ + "img/edge_activites_sentier_interpretation.1b0aaf3c.svg";